// Copyright (c) 2018 Deere & Company

import ClaimProcessInvoice from './claim-process-invoice';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.claims.dealerInvoices.busyCounter,
    invoice: state.claims.dealerInvoices.invoiceToComplete,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ClaimProcessInvoice);



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/claim-process-invoice/index.js